const moduleName = 'nav';

export function nav() {

    Array.from(document.querySelectorAll('.js-nav')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const BREAKPOINT = 1190;
        const SPEED = 600;

        const nav = self;
        const navToggle = document.querySelector('.js-nav-toggle');
        const navDropdowns = nav.querySelectorAll('.js-nav-dropdown');

        let windowWidth = document.body.clientWidth;
        let navTimer;

        navToggle.addEventListener('click', () => {
            if (nav.classList.contains('_open')) {
                hideNav();
            } else {
                showNav();
            }
        });

        window.addEventListener('resize', () => {
            const newWindowWidth = document.body.clientWidth;
            const openNavDropdowns = nav.querySelectorAll('.js-nav-dropdown._open');

                if (nav.classList.contains('_open')) hideNav();

                if (openNavDropdowns.length) {
                    Array.from(openNavDropdowns).forEach((openNavDropdown) => {
                        openNavDropdown.classList.remove('_open');
                    });
                }

            windowWidth = newWindowWidth;
        });

        Array.from(navDropdowns).forEach((navDropdown) => {
            const navDropdownToggle = navDropdown.querySelector('.js-nav-dropdown-toggle');

            navDropdownToggle.addEventListener('click', () => {

                const navDropdownMenu = navDropdown.querySelector('.js-nav-dropdown-menu');
                let navDropdownMenuHeight;

                if (navDropdown.classList.contains('_open')) {
                    navDropdownMenu.style.height = navDropdownMenu.offsetHeight + 'px';

                    setTimeout(() => {
                        navDropdownMenu.style.height = 0;

                        setTimeout(() => {
                            navDropdown.classList.remove('_open');
                            navDropdownMenu.style.height = '';
                        }, SPEED);
                    }, 1);
                } else {
                    navDropdownMenuHeight = navDropdownMenu.offsetHeight;

                    navDropdownMenu.style.height = 0;

                    setTimeout(() => {
                        navDropdown.classList.add('_open');
                        navDropdownMenu.style.height = navDropdownMenuHeight + 'px';

                        setTimeout(() => {
                            navDropdownMenu.style.height = '';
                        }, SPEED);
                    }, 1);
                }
            });

        });



        function showNav() {
            clearTimeout(navTimer);
            document.body.classList.add('nav-open');
            nav.classList.add('_visible');

            setTimeout(() => {
                overlay().show();
                nav.classList.add('_open');
            }, 10);
        }

        function hideNav() {
            nav.classList.remove('_open');
            overlay().hide();

            navTimer = setTimeout(() => {
                nav.classList.remove('_visible');
                document.body.classList.remove('nav-open');
            }, SPEED);
        }
    });

}